import { fromJS, Map as ImmutableMap } from 'immutable';
import { isJourneyReport } from 'reporting-data/tsTypes/reportTypes';
import { createSelector } from 'reselect';
import { getReportCollectionTemplates } from '../api/reportTemplatesApi';
import { getUngatedInDevReportForSubAppKey, subAppKeysByTemplateKey
// @ts-expect-error Untyped import
} from 'sales-analytics-lib/utils/get-report-config';
import requestStatusTypes from '../constants/requestStatusTypes';
import { getGatesAndScopes } from '../selectors/gatesSelector';
import { getJourneyWithValidChartType } from '../utils/journeyGenerationUtils';
import { SUB_APPS } from 'reporting-data/tsTypes/subAppTypes';
// @ts-expect-error Untyped import
import { updateCustomFiltersInTemplate } from '../utils/srvMigrationUtils';
const {
  UNINITIALIZED,
  PENDING,
  SUCCEEDED,
  FAILED
} = requestStatusTypes;
export const reportCollectionTemplatesNamespace = 'reportCollectionTemplates';
// Action types

const ACTION_TYPES = {
  FETCH_REPORT_COLLECTION_TEMPLATES_PENDING: 'FETCH_REPORT_COLLECTION_TEMPLATES_PENDING',
  FETCH_REPORT_COLLECTION_TEMPLATES_SUCCEEDED: 'FETCH_REPORT_COLLECTION_TEMPLATES_SUCCEEDED',
  FETCH_REPORT_COLLECTION_TEMPLATES_FAILED: 'FETCH_REPORT_COLLECTION_TEMPLATES_FAILED'
};
// Actions
export const fetchReportCollectionTemplates = () => (dispatch, getState) => {
  const state = getState();
  if ([SUCCEEDED, PENDING].includes(state[reportCollectionTemplatesNamespace].get('status'))) {
    return Promise.resolve();
  }
  const gatesAndScopes = getGatesAndScopes(state);
  dispatch({
    type: ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_PENDING
  });
  return getReportCollectionTemplates().then(response => {
    dispatch({
      type: ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_SUCCEEDED,
      payload: {
        response,
        gates: gatesAndScopes.gates,
        scopes: gatesAndScopes.scopes
      }
    });
  }, error => {
    console.error(error); // eslint-disable-line no-console
    dispatch({
      type: ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_FAILED,
      payload: error
    });
  });
};

// Reducers
const initialState = fromJS({
  reportCollectionTemplatesByKey: {},
  status: UNINITIALIZED
});
export const reportCollectionTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_PENDING:
      return state.setIn(['status'], PENDING);
    case ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_SUCCEEDED:
      {
        const {
          response,
          gates,
          scopes
        } = action.payload;
        const newTemplatesByKey = response.reduce((memo, template) => {
          const templateKey = template.get('templateKey');
          const withoutId = template.remove('id');
          const report = withoutId;
          if (isJourneyReport(report)) {
            return memo.set(templateKey, getJourneyWithValidChartType(report, scopes));
          }
          return memo.set(templateKey, withoutId);
        }, ImmutableMap());
        const newTemplatesAndInDevReportsByKey = newTemplatesByKey.map((template, templateKey) => {
          const subAppKey = subAppKeysByTemplateKey.get(templateKey);
          if (subAppKey === SUB_APPS.changeHistoryDealList) {
            template = updateCustomFiltersInTemplate(template);
          }
          const ungatedInDevReport = getUngatedInDevReportForSubAppKey(subAppKey, gates);
          if (ungatedInDevReport) {
            return fromJS(Object.assign({}, template.toJS(), ungatedInDevReport));
          }
          return template;
        });
        return state.setIn(['status'], SUCCEEDED).set('reportCollectionTemplatesByKey', newTemplatesAndInDevReportsByKey);
      }
    case ACTION_TYPES.FETCH_REPORT_COLLECTION_TEMPLATES_FAILED:
      return state.setIn(['status'], FAILED);
    default:
      return state;
  }
};

// Selectors
export const selectReportCollectionTemplatesRoot = state => state[reportCollectionTemplatesNamespace];
export const selectReportCollectionTemplatesByKey = createSelector(selectReportCollectionTemplatesRoot, templatesRoot => templatesRoot.get('reportCollectionTemplatesByKey'));
const selectReportCollectionTemplateRequestStatus = createSelector(selectReportCollectionTemplatesRoot, templatesRoot => templatesRoot.get('status'));
export const selectIsReportCollectionTemplateRequestPending = createSelector(selectReportCollectionTemplateRequestStatus, status => [PENDING, UNINITIALIZED].includes(status));